import Immutable from 'immutable';
import { createSelector } from 'reselect';

const summaryFromState = (state, type) => state.getIn(['borrowing', 'borrowing', 'summaries', type], Immutable.Map());

const borrowingHistorySummaryFromState = (state) => state.getIn(['borrowing', 'borrowingHistory', 'summaries', 'totalElements'], -1);

export const getSummary = createSelector(
  [summaryFromState],
  (summary) => summary
);

export const getBorrowingHistorySummary = createSelector(
  [borrowingHistorySummaryFromState],
  (summary) => summary
);

export default {
  getSummary,
  getBorrowingHistorySummary
};



// WEBPACK FOOTER //
// ./app/selectors/BorrowingSelector.js